import React, { useState } from 'react';
import { Bug } from 'lucide-react';
import BugReportModal from '../BugReportModal';

const BugReportFAB = ({
  className = '',
  style = {},
  hasWelcomeGuide = false,
  position = 'bottom-right'
}) => {
  const [isBugReportOpen, setIsBugReportOpen] = useState(false);

  // Determine position based on props
  let positionClass;
  if (position === 'bottom-left') {
    positionClass = 'fixed bottom-6 left-6';
  } else if (hasWelcomeGuide) {
    positionClass = 'fixed bottom-[78px] right-6'; // Position above welcome guide (smaller spacing)
  } else {
    positionClass = 'fixed bottom-6 right-6'; // Default position
  }

  return (
    <>
      <button
        onClick={() => setIsBugReportOpen(true)}
        className={`${positionClass} bg-gradient-to-r from-orange-500 to-red-500 hover:from-orange-600 hover:to-red-600 text-white p-3 rounded-full shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 z-20 group ${className}`}
        style={{
          background: 'linear-gradient(135deg, #FF7043, #F44336)',
          ...style
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = 'linear-gradient(135deg, #F44336, #D32F2F)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = 'linear-gradient(135deg, #FF7043, #F44336)';
        }}
        aria-label="Report Bug or Give Feedback"
      >
        <Bug className="w-5 h-5 group-hover:rotate-12 transition-transform duration-300" />

        <div
          className={`absolute bottom-full mb-2 px-3 py-2 bg-gray-900 text-white text-sm rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap pointer-events-none z-20 ${
            position === 'bottom-left' ? 'left-0' : 'right-0'
          }`}
        >
          Report Bug / Feedback
          <div
            className={`absolute top-full w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-900 ${
              position === 'bottom-left' ? 'left-4' : 'right-4'
            }`}
          ></div>
        </div>
      </button>

      <BugReportModal isOpen={isBugReportOpen} onClose={() => setIsBugReportOpen(false)} />
    </>
  );
};

export default BugReportFAB;
